/** @jsxImportSource react */
import { useState } from 'react'
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, Stack, TextField } from '@mui/material'
import FieldInput from './FieldInput'
import { toRequestData } from './fieldValues'

/** One field set to the same value (or cleared) on every selected record; each is still validated on its own. */
const BulkEditDialog = ({ open, count, fields, busy, onApply, onClose }) => {
  const [key, setKey] = useState('')
  const [value, setValue] = useState('')
  const [clear, setClear] = useState(false)
  const field = fields.find((f) => f.fieldKey === key)
  const chosen = field && (clear ? null : toRequestData({ sections: [{ fields: [field] }] }, { [key]: value })[key])
  const ready = field && (clear || chosen !== undefined)
  const reset = () => { setKey(''); setValue(''); setClear(false) }
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth TransitionProps={{ onExited: reset }}
      PaperProps={{ component: 'form', onSubmit: (e) => { e.preventDefault(); e.stopPropagation(); if (ready) onApply(key, clear ? null : chosen) } }}>
      <DialogTitle>Edit {count} {count === 1 ? 'record' : 'records'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField select label="Field" value={key} onChange={(e) => { setKey(e.target.value); setValue(''); setClear(false) }}>
            {fields.map((f) => <MenuItem key={f.fieldKey} value={f.fieldKey}>{f.label}</MenuItem>)}
          </TextField>
          {field && !clear && (
            <Box>
              <FieldInput field={{ ...field, required: false }} value={value} onChange={setValue} />
            </Box>
          )}
          {field && (
            <FormControlLabel control={<Checkbox checked={clear} onChange={(e) => setClear(e.target.checked)} />}
              label={`Clear ${field.label} instead`} disabled={!!field.required} />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" variant="contained" disabled={!ready || busy}>{busy ? 'Saving…' : 'Apply'}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default BulkEditDialog
